/* BVA pre-built kits — filter chips and one-click add of every component. */
(function () {
  'use strict';

  function init(rot) {
    if (rot.__bvak) return;
    rot.__bvak = true;
    var spara = window.vpSpara || function () {};

    var kort = Array.prototype.slice.call(rot.querySelectorAll('[data-bvak-klass]'));

    rot.querySelectorAll('[data-bvak-filter]').forEach(function (knapp) {
      knapp.addEventListener('click', function () {
        var val = knapp.getAttribute('data-bvak-filter');
        spara('bva_paket_filter', { klass: val });
        rot.querySelectorAll('[data-bvak-filter]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === knapp));
        });
        kort.forEach(function (k) {
          k.hidden = val !== 'alla' && k.getAttribute('data-bvak-klass') !== val;
        });
      });
    });

    rot.querySelectorAll('[data-bvak-add]').forEach(function (knapp) {
      knapp.addEventListener('click', function () {
        var items = knapp.getAttribute('data-bvak-items').split(',').map(function (par) {
          var d = par.split(':');
          return { id: Number(d[0]), quantity: Number(d[1]) };
        }).filter(function (i) { return i.id && i.quantity; });
        if (!items.length) return;

        var text = knapp.textContent;
        knapp.disabled = true;
        knapp.textContent = 'Lägger till …';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart');
          var kortEl = knapp.closest('[data-bvak-klass]');
          var namnEl = kortEl && kortEl.querySelector('.bvak-name');
          spara('bva_set_tillagt', { kalla: 'paketsida', artiklar: items.length,
            paket: namnEl ? namnEl.textContent.trim() : '' });
          knapp.textContent = 'Tillagt ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () { window.location.href = '/cart'; }, 700);
        }).catch(function () {
          knapp.disabled = false;
          knapp.textContent = text;
        });
      });
    });
  }

  function start() { document.querySelectorAll('[data-bva-kits]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
